import React from 'react';
import { Box, FormControl, IconButton, MenuItem, Select, Tooltip } from '@mui/material';
import { Settings as SettingsIcon } from '@mui/icons-material';
import DashboardGreeting from './DashboardGreeting';
import { DASHBOARD_COLORS } from './dashboardStyles';
import { OVERVIEW_TIME_RANGE_OPTIONS } from '../../utils/dashboardOverviewUtils';

const DashboardHeader = ({ userName, timeRange, onTimeRangeChange, onOpenSettings, showSettings }) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: { xs: 'flex-start', sm: 'center' },
      flexWrap: 'wrap',
      gap: 2,
      mb: 3,
    }}
  >
    <Box sx={{ flex: 1, minWidth: 0 }}>
      <DashboardGreeting userName={userName} embedded />
    </Box>
    <Box display="flex" alignItems="center" gap={0.5} flexShrink={0}>
      <FormControl size="small" sx={{ minWidth: 148 }}>
        <Select
          value={timeRange}
          onChange={(e) => onTimeRangeChange(e.target.value)}
          sx={{
            bgcolor: DASHBOARD_COLORS.surface,
            borderRadius: 1.5,
            fontWeight: 500,
            fontSize: '0.875rem',
            '& .MuiOutlinedInput-notchedOutline': { borderColor: DASHBOARD_COLORS.border },
            '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: DASHBOARD_COLORS.textMuted },
          }}
        >
          {OVERVIEW_TIME_RANGE_OPTIONS.map((opt) => (
            <MenuItem key={opt.value} value={opt.value}>
              {opt.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {showSettings && onOpenSettings && (
        <Tooltip title="Dashboard settings">
          <IconButton onClick={onOpenSettings} size="small" aria-label="Dashboard settings">
            <SettingsIcon />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  </Box>
);

export default DashboardHeader;
